module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_troendelag_neg.d623e35c.pdf";